// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34zTO","question":"styles_question__3MZrG","description":"styles_description__3r7b6"};